var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "layer-fullscreen px-sm-only-0 px-md-only-0 flex-column",
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.$emit('close-menu');
      }
    }
  }, [_c('div', {
    staticClass: "header flex-shrink-0 position-relative d-flex align-items-center justify-content-start justify-content-lg-center py-lg-5 d-lg-none"
  }, [_c('div', {
    staticClass: "col text-lg-center px-2"
  }, [_c('MdmIcon', {
    staticClass: "logo",
    attrs: {
      "height": "50",
      "width": "116",
      "name": "logo"
    }
  })], 1), _vm._v(" "), _c('CloseButton', {
    ref: "close",
    staticClass: "position-absolute close-field",
    nativeOn: {
      "click": function click($event) {
        return _vm.$emit('close-menu');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "layer-content d-flex flex-column flex-grow-1 flex-shrink-1 overflow-auto"
  }, [_vm._t("default")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };